import Button from "@/common/components/Button"
import { PermissionData } from "@/common/types/permissions"
import { ArrowBigRight } from "lucide-react"
import { Link } from "react-router-dom"

export class TmaisPermissionsTransformer {
  static tableTransformer() {
    return (permissions: PermissionData[]) => {
      return permissions.map((permission) => {
        return {
          ...permission,
          actions: (
            <Link to={`/tmais-permissions/${permission.id}`}>
              <Button variant="link-white" operationKlassToCheckPermission="Admin::Tmais::Permissions::Show" className="w-full">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        }
      })
    }
  }
}
